// extracted by mini-css-extract-plugin
export var drawerPaper = "_2j-0";
export var itemCard = "_2j-1";
export var itemImage = "_2j-2";